export default "__VITE_ASSET__BTqqj3ju__"